import "./Links.css";
import { FaUniversity, FaFileAlt, FaCalendarAlt, FaGraduationCap, FaBookOpen, FaBell } from "react-icons/fa";

function Links() {
  return (
    <div className="links-page">

      <h1 className="links-title">Useful Links</h1>
      <p className="links-intro">
        The following resources help students access academic services,
        examination information, scholarships and official education portals.
        These platforms support learning, administration and student development.
      </p>

      {/* University Portal */}
      <div className="link-section">
        <FaUniversity className="icon" />
        <div>
          <h2>University Portal</h2>
          <p>
            The university portal provides official updates, course materials,
            syllabus details and student academic records. Students can log in
            to access attendance, internal marks and important circulars issued
            by the university administration.
          </p>
        </div>
      </div>

      {/* Exam Results */}
      <div className="link-section">
        <FaFileAlt className="icon" />
        <div>
          <h2>Examination Results</h2>
          <p>
            Students can check semester examination results through the online
            results portal. The platform allows downloading marks memos and
            verifying academic performance for each semester.
          </p>
        </div>
      </div>

      {/* Academic Calendar */}
      <div className="link-section">
        <FaCalendarAlt className="icon" />
        <div>
          <h2>Academic Calendar</h2>
          <p>
            The academic calendar displays important academic schedules such as
            semester starting dates, examination periods, holidays and internal
            assessment timelines to help students plan their studies effectively.
          </p>
        </div>
      </div>

      {/* Scholarships */}
      <div className="link-section">
        <FaGraduationCap className="icon" />
        <div>
          <h2>Scholarships</h2>
          <p>
            Scholarship portals provide financial assistance information for
            eligible students. Students can apply for government and private
            scholarships, track application status and submit required documents
            online.
          </p>
        </div>
      </div>

      {/* Digital Library */}
      <div className="link-section">
        <FaBookOpen className="icon" />
        <div>
          <h2>Digital Library</h2>
          <p>
            The digital library offers access to e-books, journals, research
            papers and academic publications. Students can enhance knowledge and
            support project work through online learning resources.
          </p>
        </div>
      </div>

      {/* Notifications */}
      <div className="link-section">
        <FaBell className="icon" />
        <div>
          <h2>Notifications</h2>
          <p>
            This section provides latest announcements regarding admissions,
            examinations, events and academic activities. Students are advised
            to check notifications regularly to stay updated with college
            information.
          </p>
        </div>
      </div>

    </div>
  );
}

export default Links;

